/**
 * The single navy canvas that consecutive dark sections share.
 *
 * Section-rhythm rule: consecutive dark sections live inside ONE wrapper. The
 * inner <section>s carry only `relative` — no background, no overflow-hidden —
 * so the glow blobs bleed across section boundaries and the navy reads as one
 * continuous surface. Never a full-bleed border between them.
 */
export function DarkCanvas({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`relative overflow-hidden bg-navy text-surface ${className}`}>
      {children}
    </div>
  );
}
